import registrationPauseImage from "@app/assets/images/registration-pause.svg";
import { LogoutModal, Modal } from "@app/components";
import type { RootState } from "@app/redux";
import React from "react";
import { useSelector } from "react-redux";
import messages from "./messages";
import type { ViewProperties } from "./properties";
import "./registration-pause-modal.css";

export const RegistrationPauseModalView = React.memo(
	(props: ViewProperties) => {
		const { language } = useSelector((state: RootState) => state.language);

		if (props.showLogoutModal) return <LogoutModal open />;

		return (
			<Modal
				open={props.open}
				onClose={props.onClose}
				className={"registration-pause-modal overflow-auto"}
			>
				<img
					className="mb-8 mx-auto"
					src={registrationPauseImage}
					alt={messages[language].boldText}
				/>
				<h1 className="font-primary-bold mb-2.5 text-center">
					{messages[language].boldText}
				</h1>
				<h5 className="text-center mx-auto">{messages[language].subtext}</h5>
			</Modal>
		);
	},
);
